import { COOKIE_NAME } from '@holo/constants';
import { getCookie } from 'cookies-next';

export const useCartId = () => {
  const cartCookieId = getCookie(COOKIE_NAME.CART_ID)?.toString() as string;

  return cartCookieId;
};
